 export default value => value.charAt(value.length - 1) !== ".";
